export default {
  "member": "Membre du personnel",
  "avatar": "Avatar de personnel",
  "viewAvatar": "Voir avatar pour {name}",
  "search": "Rechercher le personnel par nom ou email",
  "allStatuses": "Tous les statuts",
  "allRoles": "Tous les rôles",
  "name": "Nom",
  "role": "Rôle",
  "status": "Statut",
  "certifications": "Certifications",
  "joined": "Joignez-vous",
  "joinedDate": "Entré {date}",
  "actions": "Actions",
  "grid": "Vue sur la grille",
  "list": "Vue de la liste",
  "active": "Actif",
  "inactive": "Inactif",
  "call": "Fonctionnaire d ' appel",
  "message": "Personnel du message",
  "noExtension": "Pas d ' extension assignée",
  "noExtensionBody": "Ce fonctionnaire n'a pas d'extension de téléphone.",
  "callFailed": "Incapable d'ouvrir le dialler",
  "conversationFailed": "Incapable d'ouvrir la conversation",
  "profileMissing": "Nous ne pouvions pas déterminer votre profil personnel pour la messagerie.",
  "selfMessage": "Ne pas t'envoyer un message",
  "selectOther": "Veuillez sélectionner un autre membre du personnel.",
  "retry": "Veuillez réessayer.",
  "loadError": "Impossible de charger le personnel. Veuillez réessayer.",
  "restricted": "Vous n'avez pas accès à ces dossiers de personnel.",
  "empty": "Pas de personnel trouvé",
  "emptyHelp": "Essayez d'ajuster vos filtres ou les termes de recherche.",
  "loading": "Chargement du personnel...",
  "oneResult": "Membres du personnel : {count}",
  "manyResults": "Membres du personnel : {count}",
  "clear": "Filtres transparents",
  "noCertifications": "Pas de certifications",
  "noReports": "Aucun rapport direct",
  "noManager": "Aucun gestionnaire de rapports n'a été assigné",
  "noMatches": "Pas de personnel assorti",
  "select": "Sélectionnez {name}",
  "certificationExpired": "{name} · Expiré {date}"
}
